export const cancelledLineItemMessage = (sku) => {
	return `The SKU ${sku} is not currently available for receiving. If the stock has been
    delivered and requires receiving, then select Reopen PO from the action menu.`;
};

export const overReceivedLineItemMessage = (sku) => {
	return `Attempting to receive more than what has been invoiced for SKU ${sku}. To receive an
    additional quantity of this product, you will need to create a manual purchase order in Shopkeeper.`;
};

export const overReceivedTransferLineItemMessage = (sku, diff, locationName, locationId) => {
	return `Attempting to receive more than was approved in the transfer. 
	${diff} x ${sku} will be added to ${locationName} (${locationId})`;
};

export const lineItemNotOnInvoiceMessage = (sku) => {
	return `Attempting to receive SKU ${sku} which is not part of this invoice. Please check if it
    belongs to another invoice or if supplier has sent us excess stock then raise a manual PO in
    Shopkeeper to receive it.`;
};
